<template>
    <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-2"
            >Update Absent Report</v-card-title
        >

        <v-layout row>
            <v-layout column xs6 class="pr-3" style="min-width: 50%">
                <v-layout row class="mb-2">
                    <div class="font-weight-medium width-150">Driver</div>
                    <div>{{ absent.driver }}</div>
                </v-layout>
                <v-layout row class="mb-2">
                    <div class="font-weight-medium width-150">Bus Number</div>
                    <div>{{ absent.busNumber }}</div>
                </v-layout>
                <v-layout row class="mb-2">
                    <div class="font-weight-medium width-150">Time Start</div>
                    <div>{{ absent.timeStart }}</div>
                </v-layout>
                <v-layout row class="mb-2">
                    <div class="font-weight-medium width-150">Buildings</div>
                    <div>{{ absent.buildings }}</div>
                </v-layout>
                <v-layout row class="mb-2">
                    <div class="font-weight-medium width-150">Grades</div>
                    <div>{{ absent.grades }}</div>
                </v-layout>
                <v-layout row class="mb-2">
                    <div class="font-weight-medium width-150">Entered By</div>
                    <div>{{ absent.enteredBy }}</div>
                </v-layout>
                <v-layout row class="mb-2">
                    <div class="font-weight-medium width-150">Entered On</div>
                    <div>{{ absent.enteredOn | time }}</div>
                </v-layout>

                <v-menu
                    v-model="absent.datePickerMenu"
                    :close-on-content-click="true"
                    offset-y
                    full-width
                    prepend-icon="mdi-currency-usd"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="absent.date"
                            :value="formatedDate(absent.date)"
                            label="Date"
                            prepend-icon="mdi-calendar"
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="absent.date"></v-date-picker>
                </v-menu>

                <v-select
                    v-model="absent.absentReason"
                    label="Reason"
                    :items="reasons.map((r) => r.reason)"
                    ref="absentReason"
                    :rules="[rules.required]"
                ></v-select>
            </v-layout>
            <v-layout column xs6 class="px-3" style="min-width: 50%">
                <v-text-field v-model="absent.note" label="Note"></v-text-field>
                <v-text-field
                    v-model="absent.calendarNote"
                    label="Calendar Note"
                ></v-text-field>
                <v-select
                    v-model="absent.geoUpdated"
                    label="GEO Updated"
                    :items="['YES', 'NO', 'N/A']"
                ></v-select>

                <v-select
                    v-model="absent.notifiedDriver"
                    label="Notified Driver"
                    :items="['YES', 'NO', 'N/A']"
                ></v-select>

                <div class="mt-3 mb-2 font-weight-medium">Sub Driver</div>
                <v-btn-toggle
                    v-model="updateAbsentReport.subDriverListFilter"
                    @change="subDriverListFilterChanged"
                >
                    <v-btn flat value="all" class="pa-2">
                        <span>All</span>
                    </v-btn>
                    <v-btn flat value="not_occupied" class="pa-2">
                        <span>Not Occupied</span>
                    </v-btn>
                </v-btn-toggle>

                <v-autocomplete
                    v-model="updateAbsentReport.selectedSubDriver"
                    :disabled="updateAbsentReport.isUpdatingSubDriversList"
                    :items="updateAbsentReport.subDriversDisplayList"
                    hide-details
                    box
                    chips
                    color="success"
                    class="mt-3"
                    label="Select"
                    item-text="displayName"
                    item-value="id"
                    clearable
                >
                    <template v-slot:selection="data">
                        <v-chip
                            :selected="data.selected"
                            close
                            class="chip--select-multi"
                            @input="removeSubDriver(data.item)"
                        >
                            {{ data.item.displayName }}
                        </v-chip>
                    </template>
                    <template v-slot:item="data">
                        <template v-if="typeof data.item !== 'object'">
                            <v-list-tile-content
                                v-text="data.item"
                            ></v-list-tile-content>
                        </template>
                        <template v-else>
                            <v-list-tile-content>
                                <v-list-tile-title
                                    v-html="data.item.displayName"
                                ></v-list-tile-title>
                                <v-list-tile-sub-title
                                    v-html="data.item.group"
                                ></v-list-tile-sub-title>
                            </v-list-tile-content>
                        </template>
                    </template>
                </v-autocomplete>
            </v-layout>
        </v-layout>

        <!-- <v-text-field
                    class="mx-2 mb-2"
                    v-model="rowClicked.description"
                    label="Description"
                    ref="description"
                    :rules="[rules.required]"
                ></v-text-field> -->

        <v-card-actions class="mx-0 px-2 pb-2 mt-2">
            <v-spacer></v-spacer>
            <v-btn color="default" dark @click="closeAbsentReportDialog()"
                >Cancel</v-btn
            >
            <v-btn color="warning" dark @click="deleteReports">Delete</v-btn>
            <v-btn
                :loading="processing"
                color="success"
                @click="saveAbsentReport()"
            >
                Save
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import moment from "moment";
import { getDomain, sum, toISOLocal } from "../../utils/helpers.js";

export default {
    props: {
        absent: Object,
        reload: Function,
        closeAbsentReportDialog: Function,
    },
    data() {
        return {
            processing: false,

            updateAbsentReport: {
                selectedSubDriver: "",
                isUpdatingSubDriversList: false,
                subDriversDisplayList: [],
                subDrivers: [],
                subDriverListFilter: "all",
            },

            reasons: [],

            rules: {
                required: (value) => !!value || "Required.",
            },
        };
    },
    async created() {},
    computed: {},
    watch: {
        absent(newValue, oldValue) {
            this.loadSubDriverList();
            this.loadReasons();
        },
    },
    methods: {
        async loadReasons() {
            this.reasons = await this.$http.get(
                "api/driverAbsent/GetDriverAbsentReasons",
            );
        },
        async loadSubDriverList() {
            this.updateAbsentReport.selectedSubDriver = "";

            if (this.absent.date.includes("Z")) {
                this.absent.date = toISOLocal(
                    new Date(this.absent.date),
                ).substr(0, 10);
            } else {
                this.absent.date = new Date(this.absent.date)
                    .toISOString()
                    .substr(0, 10);
            }

            const response = await this.$http.post(
                "api/driverAbsent/getSubDrivers",
                [this.absent.id],
            );

            this.updateAbsentReport.subDrivers = response
                .map((driver) => {
                    driver.displayName =
                        (driver.nameH ? driver.nameH : driver.name) +
                        " (" +
                        driver.busNumber +
                        ")";

                    driver.group = driver.isOccupied
                        ? "Occupied"
                        : "Not Occupied";

                    if (driver.position == "Substitute")
                        driver.group += ` <span class='substitute-option'>Substitute</span>`;

                    return driver;
                })
                .sort((a, b) => {
                    if (a.group < b.group) {
                        return -1;
                    }
                    if (a.group > b.group) {
                        return 1;
                    }
                    return 0;
                });

            this.updateAbsentReport.subDrivers = this.updateAbsentReport.subDrivers.reduce(
                (acc, curr) => {
                    const { group } = curr;

                    let groupHeader = group;

                    groupHeader = groupHeader.replace(
                        ` <span class='substitute-option'>Substitute</span>`,
                        ``,
                    );

                    const foundIndex = acc.findIndex(
                        (item) => item.group === groupHeader,
                    );
                    // if group is not yet added
                    if (foundIndex === -1) {
                        // add divider after full list of Not Occupied
                        if (groupHeader === "Occupied") {
                            acc.push({ divider: true });
                        }
                        acc.push({
                            header: groupHeader.toUpperCase(),
                        });
                    }
                    acc.push(curr);
                    return acc;
                },
                [],
            );

            this.updateAbsentReport.subDriversDisplayList = this.updateAbsentReport.subDrivers;

            const selectedSubDriver = this.updateAbsentReport.subDrivers.find(
                (sd) => sd.id == this.absent.subDriver_Bus_ID,
            );

            if (this.absent.subDriver_Bus_ID && selectedSubDriver) {
                this.updateAbsentReport.selectedSubDriver = selectedSubDriver;
            } else {
                this.updateAbsentReport.selectedSubDriver = "";
            }
        },
        removeSubDriver(item) {
            if (this.updateAbsentReportDialog) {
                this.updateAbsentReport.selectedSubDriver = "";
            } else {
                this.updateAbsentReport.selectedSubDriver = "";
            }
        },
        subDriverListFilterChanged(value) {
            this.updateAbsentReport.selectedSubDriver = "";
            this.updateAbsentReport.subDriversDisplayList =
                value == "all"
                    ? this.updateAbsentReport.subDrivers
                    : this.updateAbsentReport.subDrivers.filter(
                          (s) => s.group == "Not Occupied",
                      );
        },
        formatedDate(date) {
            return date ? moment(date).format("L") : "";
        },
        async deleteReports() {
            try {
                this.processing = true;

                await this.$http.post("api/driverAbsent/delete", [
                    this.absent.id,
                ]);

                this.processing = false;
                this.closeAbsentReportDialog();

                this.$notify({
                    group: "notification",
                    text: "Absent Report Deleted",
                    type: "success",
                });

                this.reload();
            } catch (e) {
                this.processing = false;
            }
        },
        async saveAbsentReport() {
            if (!this.absent.date) {
                return this.$notify({
                    text: "Date is required",
                    group: "notification",
                    type: "error",
                });
            }

            if (!this.$refs.absentReason.validate(true)) return;

            try {
                this.processing = true;

                const selectedSubDriverID =
                    typeof this.updateAbsentReport.selectedSubDriver ===
                    "number"
                        ? this.updateAbsentReport.selectedSubDriver
                        : this.updateAbsentReport.selectedSubDriver.id;

                const subDriver = this.updateAbsentReport.subDrivers.find(
                    (sd) => sd.id == selectedSubDriverID,
                );

                await this.$http.post("api/driverAbsent/save", [
                    {
                        id: this.absent.id,
                        driver_Bus_ID: this.absent.driver_Bus_ID,
                        route_ID: this.absent.route_ID,
                        date: this.absent.date,
                        subDriver_Bus_ID: subDriver ? subDriver.id : null,
                        absentReason: this.absent.absentReason,
                        absentReasonID: this.getReasonID(
                            this.absent.absentReason,
                        ),
                        note: this.absent.note,
                        calendarNote: this.absent.calendarNote,
                        geoUpdated: this.absent.geoUpdated,
                        notifiedDriver: this.absent.notifiedDriver,
                    },
                ]);

                this.processing = false;
                this.closeAbsentReportDialog();

                this.$notify({
                    group: "notification",
                    text: "Changes Saved",
                    type: "success",
                });

                this.reload();
            } catch (e) {
                console.log(e);
                this.processing = false;
            }
        },
        getReasonID(reason) {
            const data = this.reasons.find((r) => r.reason == reason);

            return data ? data.id : null;
        },
    },
};
</script>
<style>
.scroll-container {
    height: 100%;
    overflow-y: scroll;
    backface-visibility: hidden;
}
.substitute-option {
    font-size: 12px;
    background-color: purple;
    color: #fff;
    width: fit-content;
    padding: 3px;
    margin-bottom: 2px;
    border-radius: 5px;
}
</style>
